/* istanbul ignore next */
export const isServer = () => typeof window === 'undefined';
